import styled from 'styled-components';
import { DEVICES } from '_constants';
import * as Shared from '../styles';

// The modal is auto-width, so three fixed 135px buttons (Cancel / Detach / Detach from
// all) stretched it far wider than its own text. Cap the content width here and let the
// buttons share the row, wrapping their labels instead of each claiming a min-width track.
export const ModalWrapper = styled(Shared.ModalWrapper)`
  max-width: 420px;

  @media ${DEVICES.mobileXL} {
    min-width: 0;
    max-width: 100%;
  }
`;

export const ModalButtonWrapper = styled(Shared.ModalButtonWrapper)`
  align-items: stretch;
  gap: 10px;

  button {
    flex: 1 1 0;
    min-width: 0;
    height: auto;
    min-height: 40px;
    padding: 6px 8px;

    &:not(:last-child) {
      margin-right: 0;
    }

    > span {
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
      text-align: center;
      line-height: 1.2;
      padding: 0;
    }
  }
`;
